module.exports = __webpack_public_path__ + "static/media/corujas-black-without-text.073eb1b2.svg";